import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/differenceInCalendarMonths/index.js';

var require$$37 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$37 as default };
